var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubadmin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8877 7.89966C17.5681 7.80479 18.192 7.46908 18.646 6.95346C19.1 6.43784 19.3541 5.7765 19.3621 5.08954C19.37 4.40258 19.1314 3.73554 18.6895 3.2095C18.2476 2.68347 17.6317 2.33332 16.9537 2.22266",
    stroke: "#3A4B55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.729 11.25C20.08 11.45 21.023 11.925 21.023 12.9C21.023 13.571 20.579 14.007 19.861 14.281",
    stroke: "#3A4B55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8868 11.6631C7.67278 11.6631 4.92773 12.1501 4.92773 14.0951C4.92773 16.0401 7.65578 16.5401 10.8868 16.5401C14.1008 16.5401 16.8447 16.0581 16.8447 14.1121C16.8447 12.1661 14.1178 11.6631 10.8868 11.6631Z",
    stroke: "#3A4B55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.887 8.88751C11.896 8.8838 12.8622 8.4799 13.5737 7.76447C14.2852 7.04903 14.6838 6.08053 14.682 5.07153C14.6801 4.06254 14.278 3.0955 13.5638 2.38269C12.8497 1.66988 11.8819 1.26953 10.8729 1.26953C9.86393 1.26953 8.8962 1.66988 8.18207 2.38269C7.46795 3.0955 7.06583 4.06254 7.06397 5.07153C7.06212 6.08053 7.46069 7.04903 8.17219 7.76447C8.88369 8.4799 9.84996 8.8838 10.859 8.88751H10.887Z",
    stroke: "#3A4B55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88472 7.89966C4.20429 7.80479 3.58042 7.46908 3.12641 6.95346C2.67241 6.43784 2.41834 5.7765 2.41035 5.08954C2.40236 4.40258 2.641 3.73554 3.0829 3.2095C3.52479 2.68347 4.14064 2.33332 4.81868 2.22266",
    stroke: "#3A4B55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.04401 11.25C1.69301 11.45 0.75 11.925 0.75 12.9C0.75 13.571 1.19399 14.007 1.91199 14.281",
    stroke: "#3A4B55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubadmin);
export default __webpack_public_path__ + "static/media/subadmin.2d874638d674f17d13b0e379ff7f6f18.svg";
export { ForwardRef as ReactComponent };